import { render } from "./SoftwareDevelopment.vue?vue&type=template&id=8e86efb8"
import script from "./SoftwareDevelopment.vue?vue&type=script&lang=js"
export * from "./SoftwareDevelopment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__